module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-15.eea01a73.png";